import type { FaireProductEntity } from "../../entity_types/product";

export const p_tp7rrppd5p: FaireProductEntity = {
  token: "p_tp7rrppd5p",
  type: "product",
  name: 'Herkimer Diamond 1.5"',
  brandToken: "b_wmrj23yq37",
  brandName: "Wildheart Crystals",
  imageUrl:
    "https://cdn.faire.com/fastly/ad4dc22957b7077d2cb5d6430e595caff47596e3863de77fbdf0f39f61a58d3d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8cad60f05effab54642dfad1bbfee8678a2728450795d1a3707429e67c155210.jpeg",
    "https://cdn.faire.com/fastly/f0d845a7264507916dda5780083a22be6a08075da019913ac5db3c3d13ae7c3c.jpeg",
    "https://cdn.faire.com/fastly/79eb8544445942c6a58356ca9b6a9d94a299c5529e85479b4d5601112de3cadb.jpeg",
    "https://cdn.faire.com/fastly/43938dd79d81b65a5907b136f8c2ee6366ada3766b63f3d4dc054efd14c7e290.jpeg",
    "https://cdn.faire.com/fastly/7efe4bc1f5813c0e3ee52535017c908f094c55f65026e5595a638af11507aa93.jpeg",
    "https://cdn.faire.com/fastly/f1cc07c956821d136cfb03d804287bbd7f414ff96aa56995d9a23fb2aed44b57.jpeg",
    "https://cdn.faire.com/fastly/c83c3080f851bfa5cb6c548a66ffa5a496cae78911f404709b505af2b0d20bb9.jpeg",
    "https://cdn.faire.com/fastly/e8fd55fba2a81bb3211827f866114927c2cd1d8507774346bed294456d5ec7bb.jpeg",
  ],
  priceDollars: 23.56,
  description:
    "Embrace the raw beauty and spiritual resonance of our 1.5\" Herkimer Diamond. As part of Wildheart Crystals' collection, this natural gemstone from New York exudes an organic elegance that aligns with the metaphysical influences of natural gemstones. Each Herkimer Diamond is a testament to our commitment to sturdy, high-quality pieces and our celebration of gems in their natural, untreated state. Perfect for those on a spiritual journey or simply appreciating nature's gifts.",
  tags: [],
  msrpDollars: 47.11,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:55:11.438Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
